
export default {
  name: 'EmptyLayout'
}
